/* eslint-disable */
import React from "react";
import { Route, Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

const RouteWithLayout = (props) => {
  const {
    layout: Layout,
    component: Component,
    componentProps,
    requireAuthentication,
    authenticated,
    ...rest
  } = props;

  const { selectedPaymentType, currentUser } = useSelector(
    (state) => state.auth
  );
  const userRole = currentUser?.author?.role;

  return (
    <Route
      {...rest}
      render={(matchProps) => {
        const compProps = { ...matchProps, ...componentProps };

        if (requireAuthentication && !authenticated) {
          return <Redirect to="/login" />;
        }

        if (
          requireAuthentication &&
          authenticated &&
          userRole === "author" &&
          !selectedPaymentType
        ) {
          return <Redirect to="/payment-integration" />;
        }

        return (
          <Layout>
            <Component {...compProps} />
          </Layout>
        );
      }}
    />
  );
};

RouteWithLayout.defaultProps = {
  componentProps: {},
  requireAuthentication: false,
  authenticated: false,
};

RouteWithLayout.propTypes = {
  layout: PropTypes.elementType.isRequired,
  component: PropTypes.elementType.isRequired,
  componentProps: PropTypes.object,
  path: PropTypes.string,
  requireAuthentication: PropTypes.bool,
  authenticated: PropTypes.bool,
};

export default RouteWithLayout;
